import React, { useState } from "react";
import "./navbar.css";
import { MdOutlineFavoriteBorder } from "react-icons/md";
import { BiPhoneCall } from "react-icons/bi";
function Navbar(props) {
  const [logo, setlogo] = useState("light");
  window.addEventListener("scroll", () => {
    document.getElementById("nav").classList.toggle("blur", window.scrollY > 0);
    document
      .querySelector(
        "#navbarSupportedContent > ul > li.nav-item.mx-3.dropdown > a"
      )
      .classList.toggle("text-black", window.scrollY > 0);
    document
      .getElementById("navlink1")
      .classList.toggle("text-black", window.scrollY > 0);

    document
      .getElementById("navlink2")
      .classList.toggle("text-black", window.scrollY > 0);

    document
      .getElementById("navlink3")
      .classList.toggle("text-black", window.scrollY > 0);
    window.scrollY > 0 && setlogo("dark");
    window.scrollY === 0 && setlogo("light");
  });
  return (
    <nav
      id="nav"
      className={`navbar navbar-expand-lg  ${props.color} fixed-top bg-transparent`}
    >
      <div className="container-fluid">
        <a className="navbar-brand" href="#">
          <img
            src={`https://mirabad.uz/webicons/header/media/logo_${logo}.svg`}
            alt=""
          />
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
            <li className="nav-item mx-3 dropdown">
              <a
                className="nav-link mx-3 dropdown-toggle"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                О проекте
              </a>
              <ul className="dropdown-menu">
                <li>
                  <a className="dropdown-item" href="#">
                    О проекте
                  </a>
                </li>
                <li>
                  <a className="dropdown-item" href="#">
                    Расположение
                  </a>
                </li>
                <li>
                  <hr className="dropdown-divider" />
                </li>
                <li>
                  <a className="dropdown-item" href="#">
                    Ход строительства
                  </a>
                </li>
                <li>
                  <a className="dropdown-item" href="#">
                    Материалы
                  </a>
                </li>{" "}
                <li>
                  <a className="dropdown-item" href="#">
                    Контакты
                  </a>
                </li>
              </ul>
            </li>
            <li className="nav-item mx-3">
              <a
                id="navlink1"
                className="nav-link active"
                aria-current="page"
                href="#"
              >
                <span className="mx-2">Квартиры </span> <span>По</span>{" "}
                <span className="mx-2">параметрам</span>
              </a>
            </li>
            <li className="nav-item ">
              <a id="navlink2" className="nav-link fs-4 " href="#">
                <MdOutlineFavoriteBorder />
              </a>
            </li>
            <li className="nav-item mx-3">
              <a id="navlink3" className="nav-link font-weight-bold" href="#">
                <strong>+998 93 150 55 55</strong>
              </a>
            </li>
            <li className="nav-item mx-3">
              <a
                className="nav-link font-weight-bold badge bg-success"
                href="#"
              >
                <span className="fs-5">
                  <BiPhoneCall />
                </span>{" "}
                <span> Заказ звонка</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
